<header
  class="sticky top-0 flex w-full bg-white border-gray-200 z-99999 dark:border-gray-800 dark:bg-gray-900 xl:border-b">
  <div class="flex flex-col items-center justify-between grow xl:flex-col xl:items-stretch xl:px-6">
    <div
      class="flex items-center justify-between w-full gap-2 px-3 py-3 border-b border-gray-200 dark:border-gray-800 sm:gap-4 xl:justify-between xl:border-b-0 xl:px-0 lg:py-4">
      <button
        class="items-center justify-center  w-10 h-10 text-gray-500 border-gray-200 rounded-lg z-99999 dark:border-gray-800 flex dark:text-gray-400 lg:h-11 lg:w-11 xl:border"
        [ngClass]="{
          'bg-gray-100 dark:bg-white/[0.03]': isMobileOpen$ | async
        }"
        (click)="handleToggle()" aria-label="Toggle Sidebar">
        @if (isMobileOpen$ | async) {
          <!-- Cross Icon -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
              fill="currentColor" />
          </svg>
        } @else {
          <!-- Hamburger Icon -->
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
              fill="currentColor" />
          </svg>
        }
      </button>
      <!-- Logo (placeholder) -->
      <a routerLink="/" class="xl:hidden">
        <img class="dark:hidden" src="images/logo/logoh.png" alt="Logo" />
      </a>
      <div class="flex w-full gap-2 align-middle justify-between items-center">
          <div class="flex  items-center">
            <button
              type="button"
              class="inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-1.5 text-sm font-medium text-gray-700 shadow-xs hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
              (click)="openFilterDrawer()"
            >
              <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M2.5 5.75A.75.75 0 0 1 3.25 5h13.5a.75.75 0 0 1 .53 1.28l-5.03 5.03v4.44a.75.75 0 0 1-1.28.53l-2-2a.75.75 0 0 1-.22-.53v-2.44L2.72 6.28a.75.75 0 0 1-.22-.53Z" />
              </svg>
              {{ 'app.label.filters' | translate }}
              @if (filterStore.activeFilterCount() > 0) {
                <span class="rounded-full bg-gray-900 px-2 py-0.5 text-xs font-semibold text-white dark:bg-white dark:text-gray-900">
                  {{ filterStore.activeFilterCount() }}
                </span>
              }
            </button>
          </div>
          <div class="flex items-center gap-4">
          @if (filterStore.selectedPills().length > 0 || filterStore.selectedPeriodPill()) {
            <div class="col-span-2 flex min-w-0 flex-wrap items-center gap-2 justify-end">
              @if (filterStore.selectedPeriodPill(); as pill) {
                <span class="inline-flex max-w-full items-center gap-2 rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700 dark:bg-blue-950 dark:text-blue-200">
                  <span class="truncate"><span class="text-blue-600 dark:text-blue-400">{{ pill.label }}:</span> {{ pill.value }}</span>
<!--                  <button-->
<!--                    type="button"-->
<!--                    class="rounded-full p-0.5 text-blue-600 hover:bg-blue-200 hover:text-blue-700 dark:text-blue-400 dark:hover:bg-blue-900 dark:hover:text-blue-200"-->
<!--                    (click)="removePeriodPill()"-->
<!--                  >-->
<!--                    <span class="sr-only">Remove {{ pill.label }}</span>-->
<!--                    <svg class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">-->
<!--                      <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />-->
<!--                    </svg>-->
<!--                  </button>-->
                </span>
              }
              @for (pill of filterStore.selectedPills(); track pill.key) {
                <span class="inline-flex max-w-full items-center gap-2 rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-200">
                  <span class="truncate"><span class="text-gray-500 dark:text-gray-400">{{ pill.label }}:</span> <span class="capitalize">{{ pill.value }}</span></span>
<!--                  <button-->
<!--                    type="button"-->
<!--                    class="rounded-full p-0.5 text-gray-500 hover:bg-gray-200 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-100"-->
<!--                    (click)="removePill(pill)"-->
<!--                  >-->
<!--                    <span class="sr-only">Remove {{ pill.label }}</span>-->
<!--                    <svg class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">-->
<!--                      <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />-->
<!--                    </svg>-->
<!--                  </button>-->
                </span>
              }
            </div>
          }
          </div>
          <div class="flex gap-2 items-center justify-end">
            <!-- NotificationDropdown placeholder -->
<!--            <app-notification-dropdown />-->
            <!-- UserDropdown placeholder -->
            <app-user-dropdown />

            <app-locale-switcher />
          </div>

      </div>

    </div>

  </div>
</header>
